import { render, staticRenderFns } from "./saveManagementDetail.vue?vue&type=template&id=2a7c3cc0"
import script from "./saveManagementDetail.vue?vue&type=script&lang=js"
export * from "./saveManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./saveManagementDetail.vue?vue&type=style&index=0&id=2a7c3cc0&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a7c3cc0')) {
      api.createRecord('2a7c3cc0', component.options)
    } else {
      api.reload('2a7c3cc0', component.options)
    }
    module.hot.accept("./saveManagementDetail.vue?vue&type=template&id=2a7c3cc0", function () {
      api.rerender('2a7c3cc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/manage/saveManagementDetail.vue"
export default component.exports